// AUTO-GENERATED from services/app-api-service/codeigniter/application/contracts/Migration_PreflightCatalogoResponse.php
// Do not edit by hand — edit the PHP ResponseContract and the sync hook will regenerate this file.
// Bulk regeneration: scripts/sync-contracts/sync-all.sh

/**
 * ResponseContract de GET /migration/catalogo/preflight
 * (controllers/migration/catalogo.php::preflight).
 *
 * Uma linha por registro do catalogo da franquia pedida, com o de-para ja
 * executado (tipo, categoria, centavos, prazo), os blockers e se ja veio.
 * Leitura pura — nada foi escrito para montar isto.
 */
import type { Migration_PreflightCatalogoRow } from './Migration_PreflightCatalogoRow'
import type { ApiResponse } from '../services/httpService'
import { registerResponseContract } from './validate'

export interface Migration_PreflightCatalogoResponseDados {
registros: Migration_PreflightCatalogoRow[]
}

export type Migration_PreflightCatalogoResponse = ApiResponse<Migration_PreflightCatalogoResponseDados>;

registerResponseContract('Migration_PreflightCatalogoResponse', {
  registros: {
    type: 'array',
    required: true,
    items: {
      zoho_id:        { type: 'string',  required: false },
      nome:           { type: 'string',  required: false },
      tipo:           { type: 'string',  required: false },
      categoria:      { type: 'string',  required: false },
      preco_centavos: { type: 'number',  required: false },
      prazo:          { type: 'string',  required: false },
      ativo:          { type: 'number',  required: false },
      ja_migrado:     { type: 'boolean', required: false },
      blockers: {
        type: 'array',
        required: false,
        items: {
          code:     { type: 'string',  required: false },
          message:  { type: 'string',  required: false },
          severity: { type: 'string',  required: false },
          entity:   { type: 'string',  required: false },
          zoho_id:  { type: 'string',  required: false },
          label:    { type: 'string',  required: false },
        },
      },
      destino:        { type: 'object',  required: false },
    },
  },
})
